export default class PagedResult {
  total = 0
  items = []
}
